<template>
  <div class="animated fadeIn">
    <h3>Feed Mixer Efficiency Report</h3>
    <b-table :items="samples" :fields="columns" responsive bordered>
      <template #cell(sample_id)="data">
        {{ data.item.number }}<br />
        {{ data.item.id }}
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "SubmissionMixerEfficiencyReport",
  props: {
    samples: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        { key: "sample_id", label: "Sample ID" },
        { key: "unit", label: "Units" },
        { key: "calcium", label: "Calcium" },
        { key: "standard_deviation", label: "Standard Deviation" },
        { key: "variation_coefficient", label: "Coefficient of Variation" },
      ],
    };
  },
};
</script>
